import React, { useContext, useState, useEffect } from 'react'
import ModalContext from '../../contexts/ModalContext'
import {
  Container,
  CloseDiv,
  HeaderText,
  Input,
  Input2,
  InputDiv,
  InputLabel,
  InputLabel2,
  SelectInputMoviment,
  SelectInputKgOrMm,
  SelectOption,
  CloseImg,
  SwitchesDiv,
  SwitchDiv,
  SwitchLabel,
  SwitchBox,
  SwitchInput,
  SwitchSlider,
  InputText,
  InputDivText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
  ButtonsDiv,
  WarningDiv,
  WarningText,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  InputLabel3,
  HeaderDiv,
  InputRowDiv,
} from './style'
import StockContext from '../../contexts/StockContext'
import cross from '../../assets/addStockModal/cross.svg'
import diskIcon from '../../assets/addStockModal/pages/disk.svg'
import arrowLeft from '../../assets/addStockModal/pages/arrow-left.svg'
import axios from 'axios'

const EntryOrExit = () => {
  const { setModalActive, setModalSection, itIsUpdate } =
    useContext(ModalContext)
  const { stock, setStock } = useContext(StockContext)
  const [movementType, setMovementType] = useState<string>('Entrada')
  const [observation, setObservation] = useState<string>('')
  const [unitOfMeasurement, setUnitOfMeasurement] = useState<string>('KG')
  const [updateInOmie, setUpdateInOmie] = useState<boolean>(false)
  const [updateInStock, setUpdateInStock] = useState<boolean>(false)
  const [warningMessage, setWarningMessage] = useState<string>('')
  const [quantity, setQuantity] = useState<string>('')

  useEffect(() => {
    setWarningMessage('')
  }, [stock, updateInOmie, updateInStock])

  const clickEdit = () => {
    setModalSection('modalEntryOrExit')
  }

  const handleSelectChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target

    switch (name) {
      case 'movementType':
        setMovementType(value)
        break
      case 'observation':
        setObservation(value)
        break
      case 'unitOfMeasurement':
        setUnitOfMeasurement(value)
        break
      default:
        setStock({
          ...stock,
          [name]: value,
        })
        break
    }
  }

  const switches: string[] = ['omie', 'updateInStock']
  const switchesText: string[] = [
    unitOfMeasurement === 'KG'
      ? 'Movimentar peso na Omie'
      : 'Movimentar comp. na Omie',
    unitOfMeasurement === 'KG'
      ? 'Movimentar peso no estoque'
      : 'Movimentar comp. no estoque',
  ]
  const switchValues: boolean[] = [updateInOmie, updateInStock]

  const WarningBox = () => {
    return (
      <WarningDiv>
        <WarningText>{warningMessage}</WarningText>
      </WarningDiv>
    )
  }

  const handleSwitchToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target
    switch (name) {
      case 'omie':
        setUpdateInOmie(!updateInOmie)
        break
      case 'updateInStock':
        setUpdateInStock(!updateInStock)
        break
      default:
        console.log('Caminho inesperado ao ativar um switch toggle')
        break
    }
  }

  const handleSubmit = async () => {
    if (!quantity.trim()) {
      setWarningMessage('O campo Peso não pode estar vazio.')
      return
    }

    if (!updateInOmie && !updateInStock) {
      setWarningMessage('Ative pelo menos uma opção de atualização.')
      return
    }

    setWarningMessage('') // Se tudo estiver certo, limpa a mensagem
    // Aqui você pode chamar a função que realmente processa o salvamento.

    const newEntry = {
      codeId: stock.codeId,
      movementType: movementType, // Pegando o tipo de entrada/saída
      quantity,
      updateInOmie,
      updateInStock,
      observation: observation,
      unitOfMeasurement: unitOfMeasurement,
    }
    const token = localStorage.getItem('token')
    try {
      setWarningMessage('Salvando...')
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/handle-stock-movement`,
        newEntry,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Substitua por sua lógica de autenticação
            'Content-Type': 'application/json',
          },
        },
      )

      if (response) {
        setModalActive(false)
      }
    } catch (error) {
      console.error('Erro ao salvar os dados:', error)
      setWarningMessage(
        'Erro ao salvar os dados. Verifique os campos e tente novamente.',
      )
    }
  }

  const productDetailsModal = () => {
    setModalSection('newModal')
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>
          {itIsUpdate
            ? `Novo Movimento - ${stock.description}`
            : 'Adicionar Estoque'}
        </HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <InputRowDiv>
        <InputDiv>
          <InputLabel>Tipo</InputLabel>
          <SelectInputMoviment
            name='movementType'
            value={movementType}
            onChange={(e) => handleSelectChange(e)}
          >
            <SelectOption value='Entrada'>ENTRADA</SelectOption>
            <SelectOption value='Saída'>SAÍDA</SelectOption>
          </SelectInputMoviment>
        </InputDiv>
        <InputDiv>
          <InputLabel>Unidade</InputLabel>
          <SelectInputKgOrMm
            name='unitOfMeasurement'
            value={unitOfMeasurement}
            onChange={(e) => handleSelectChange(e)}
          >
            <SelectOption value='KG'>KG</SelectOption>
            <SelectOption value='MM'>MM</SelectOption>
          </SelectInputKgOrMm>
        </InputDiv>
      </InputRowDiv>
      <br />
      <InputRowDiv>
        <InputDiv>
          <InputLabel>
            {unitOfMeasurement === 'KG' ? 'Peso atual' : 'Comprimento atual'}
          </InputLabel>
          <Input
            value={
              unitOfMeasurement === 'KG' ? stock.totalWeight : stock.lengthInMm
            }
            disabled
          />
        </InputDiv>

        <InputDiv>
          <InputLabel>Quantidade</InputLabel>
          <Input
            placeholder='Digite aqui'
            type='number'
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </InputDiv>
      </InputRowDiv>
      <SwitchesDiv>
        {switches.map((field, index) => (
          <SwitchDiv key={field}>
            <SwitchLabel htmlFor={field}>{switchesText[index]}</SwitchLabel>
            <SwitchBox>
              <SwitchInput
                type='checkbox'
                name={field}
                checked={switchValues[index]}
                onChange={handleSwitchToggle}
              />
              <SwitchSlider className='slider'></SwitchSlider>
            </SwitchBox>
          </SwitchDiv>
        ))}
      </SwitchesDiv>
      <InputRowDiv>
        <InputDiv>
          <InputLabel>Observação</InputLabel>
          <InputText
            name='observation'
            value={observation}
            onChange={(e) => handleSelectChange(e)}
            autoFocus
          />
        </InputDiv>
      </InputRowDiv>
      <ButtonsDiv>
        <WarningBox />
        <PreviousButtonDiv onClick={productDetailsModal}>
          <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
          <PreviousButtonText>Voltar</PreviousButtonText>
        </PreviousButtonDiv>
        <NextButtonDiv
          onClick={() => handleSubmit()}
          className={warningMessage !== '' ? 'disabled' : ''}
        >
          <NextButtonImage src={diskIcon} alt='Right arrow icon' />
          <NextButtonText>Salvar</NextButtonText>
        </NextButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default EntryOrExit
